import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import WizardStepLayout from '../../components/common/WizardStepLayout';
import { useLocalizedMessage } from '../../../../util/useLocalizedMessage';
import styles from './WelcomeStep.module.scss';

const heroImage = require('../../../../assets/wizard-integration/integration-wizard-welcome.png');

const WelcomeStep = ({ onReady, productId }) => {
  const localizeMessage = useLocalizedMessage();
  // Always ready - this is just informational step
  useEffect(() => {
    if (onReady) {
      onReady(true);
    }
  }, [onReady]);

  return (
    <WizardStepLayout maxWidth="wide" noMaxWidth>
      <Box className={`${styles.container} ${productId === 'cloud' ? styles.cloud : ''}`}>
        <Box className={styles.contentSection}>
          <Box className={styles.textContent}>
            <div className={styles.eyebrow}>
              {localizeMessage('wizard.searchSetup.flowLabel')}
            </div>
            <h1>{localizeMessage('wizard.searchSetup.welcome.title')}</h1>
            <p className={styles.subtitle}>
              {localizeMessage('wizard.searchSetup.welcome.subtitle')}
            </p>

            <ul className={styles.benefitsList}>
              <li>{localizeMessage('wizard.searchSetup.welcome.benefit.layout')}</li>
              <li>{localizeMessage('wizard.searchSetup.welcome.benefit.behavior')}</li>
              <li>{localizeMessage('wizard.searchSetup.welcome.benefit.theme')}</li>
              <li>{localizeMessage('wizard.searchSetup.welcome.benefit.publish')}</li>
            </ul>
          </Box>
        </Box>

        <Box className={styles.imageSection}>
          <img src={heroImage} alt={localizeMessage('wizard.searchSetup.welcome.imageAlt')} />
        </Box>
      </Box>
    </WizardStepLayout>
  );
};

WelcomeStep.propTypes = {
  onReady: PropTypes.func,
  productId: PropTypes.string,
};

WelcomeStep.defaultProps = {
  onReady: null,
  productId: null,
};

export default WelcomeStep;
